import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext } from 'react';
import { di } from 'react-magnetic-di';
import { fg } from '@atlaskit/platform-feature-flags';
import { setRovoChatProduct } from '../../common/utils/product-config';
import { readJsonStream } from './read-json-stream';
import { isHumanMessage } from './types';
import { addPath, processResponse } from './utils/client';
import { generateConversationName } from './utils/conversation';
import { toStreamResponse } from './utils/data';
import { fetchFn } from './utils/fetch';
var PRODUCT_HEADER = 'x-product';
var EXPERIENCE_ID_HEADER = 'x-experience-id';
export var AssistanceServiceImpl = /*#__PURE__*/function () {
  function AssistanceServiceImpl(props) {
    var _this = this;
    _classCallCheck(this, AssistanceServiceImpl);
    _defineProperty(this, "getConfig", function () {
      return _objectSpread({}, _this.config);
    });
    _defineProperty(this, "getAgentActions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.fetchJson({
              path: '/agents/configuration/v1/actions',
              options: {
                method: 'GET',
                headers: _this.createHeaders()
              }
            });
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.actions);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(this, "getAgentKnowledgeConfiguration", function () {
      return _this.fetchJson({
        path: '/agents/configuration/v1/knowledge',
        options: {
          method: 'GET',
          headers: _this.createHeaders()
        }
      });
    });
    var defaultConfig = {
      baseUrl: '/gateway/api/assist',
      headers: {}
    };
    this.config = _objectSpread(_objectSpread({}, props), {}, {
      baseUrl: props.baseUrl || defaultConfig.baseUrl,
      headers: _objectSpread({}, props.headers || defaultConfig.headers)
    });
  }
  _createClass(AssistanceServiceImpl, [{
    key: "createHeaders",
    value: function createHeaders(init) {
      var _objectSpread2;
      return new Headers(_objectSpread(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, PRODUCT_HEADER, this.config.product), _defineProperty(_objectSpread2, EXPERIENCE_ID_HEADER, this.config.experienceId), _objectSpread2), this.config.headers || {}), init || {}));
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
        var path, options, baseUrl, requestUrl, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              path = _ref2.path, options = _ref2.options;
              baseUrl = this.config.baseUrl;
              requestUrl = addPath(baseUrl, path);
              _context2.next = 5;
              return fetchFn(requestUrl, options);
            case 5:
              response = _context2.sent;
              return _context2.abrupt("return", processResponse({
                response: response
              }));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "fetchJson",
    value: function () {
      var _fetchJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
        var path, options, response, json;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              path = _ref3.path, options = _ref3.options;
              _context3.next = 3;
              return this.fetch({
                path: path,
                options: options
              });
            case 3:
              response = _context3.sent;
              _context3.next = 6;
              return response.json();
            case 6:
              json = _context3.sent;
              return _context3.abrupt("return", json);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchJson(_x2) {
        return _fetchJson.apply(this, arguments);
      }
      return fetchJson;
    }()
  }, {
    key: "fetchStream",
    value: function () {
      var _fetchStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4) {
        var path, options, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              path = _ref4.path, options = _ref4.options;
              _context4.next = 3;
              return this.fetch({
                path: path,
                options: options
              });
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", readJsonStream(response));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchStream(_x3) {
        return _fetchStream.apply(this, arguments);
      }
      return fetchStream;
    }()
  }, {
    key: "sendMessageStream",
    value: function () {
      var _sendMessageStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5) {
        var _browserContext$conte, _window, _browserContext$conte2, _browserContext$conte3;
        var agentNamedId, agentId, message, conversationId, controller, _ref5$storeMessage, storeMessage, _ref5$citationsEnable, citationsEnabled, editorContext, browserContext, additionalContext, headers, url, body, options;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              agentNamedId = _ref5.agentNamedId, agentId = _ref5.agentId, message = _ref5.message, conversationId = _ref5.conversationId, controller = _ref5.controller, _ref5$storeMessage = _ref5.storeMessage, storeMessage = _ref5$storeMessage === void 0 ? false : _ref5$storeMessage, _ref5$citationsEnable = _ref5.citationsEnabled, citationsEnabled = _ref5$citationsEnable === void 0 ? true : _ref5$citationsEnable, editorContext = _ref5.editorContext, browserContext = _ref5.browserContext, additionalContext = _ref5.additionalContext;
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              }); // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
              url = browserContext ? (_browserContext$conte = browserContext.context) === null || _browserContext$conte === void 0 ? void 0 : _browserContext$conte.browserUrl : (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.href;
              body = {
                content: message,
                context: _objectSpread(_objectSpread(_objectSpread({
                  browser_url: url
                }, editorContext ? {
                  editor: editorContext
                } : {}), browserContext ? {
                  browser: {
                    htmlBody: (_browserContext$conte2 = browserContext.context) === null || _browserContext$conte2 === void 0 ? void 0 : _browserContext$conte2.htmlBody,
                    canvasText: (_browserContext$conte3 = browserContext.context) === null || _browserContext$conte3 === void 0 ? void 0 : _browserContext$conte3.canvasText
                  }
                } : {}), additionalContext),
                recipient_agent_named_id: agentNamedId,
                agent_id: agentId,
                mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
                // don't allow store message if feature flag is off
                store_message: fg('ai_mate_show_store_messages') ? storeMessage : false,
                citations_enabled: citationsEnabled
              };
              options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context5.abrupt("return", this.fetchStream({
                path: "/chat/v1/channel/".concat(conversationId, "/message/stream"),
                options: options
              }));
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function sendMessageStream(_x4) {
        return _sendMessageStream.apply(this, arguments);
      }
      return sendMessageStream;
    }()
  }, {
    key: "getChat",
    value: function () {
      var _getChat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(conversationId) {
        var headers, options, rawChat;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers
              };
              _context6.next = 4;
              return this.fetchJson({
                path: "/chat/v1/channel/".concat(conversationId, "/messages"),
                options: options
              });
            case 4:
              rawChat = _context6.sent;
              return _context6.abrupt("return", rawChat.map(function (message) {
                return (
                  // Must be converted into StreamResponse
                  isHumanMessage(message) ? message : toStreamResponse(message)
                );
              }));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getChat(_x5) {
        return _getChat.apply(this, arguments);
      }
      return getChat;
    }()
  }, {
    key: "deleteChat",
    value: function () {
      var _deleteChat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(conversationId, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'DELETE',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              _context7.next = 4;
              return this.fetch({
                path: "/chat/v1/channel/".concat(conversationId),
                options: options
              });
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function deleteChat(_x6, _x7) {
        return _deleteChat.apply(this, arguments);
      }
      return deleteChat;
    }()
  }, {
    key: "getFeatures",
    value: function () {
      var _getFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context8.abrupt("return", this.fetchJson({
                path: 'features',
                options: options
              }));
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getFeatures(_x8) {
        return _getFeatures.apply(this, arguments);
      }
      return getFeatures;
    }()
  }, {
    key: "getAgents",
    value: function () {
      var _getAgents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context9.abrupt("return", this.fetchJson({
                path: 'agents/v1',
                options: options
              }));
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getAgents(_x9) {
        return _getAgents.apply(this, arguments);
      }
      return getAgents;
    }()
  }, {
    key: "getAgentDetails",
    value: function () {
      var _getAgentDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(id, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context10.abrupt("return", this.fetchJson({
                path: "agents/v1/".concat(id),
                options: options
              }));
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getAgentDetails(_x10, _x11) {
        return _getAgentDetails.apply(this, arguments);
      }
      return getAgentDetails;
    }()
  }, {
    key: "getAgentDetailsByIdentityAccountId",
    value: function () {
      var _getAgentDetailsByIdentityAccountId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(identityAccountId, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context11.abrupt("return", this.fetchJson({
                path: "agents/v1/accountid/".concat(identityAccountId),
                options: options
              }));
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getAgentDetailsByIdentityAccountId(_x12, _x13) {
        return _getAgentDetailsByIdentityAccountId.apply(this, arguments);
      }
      return getAgentDetailsByIdentityAccountId;
    }()
  }, {
    key: "getAgentFileUploadToken",
    value: function () {
      var _getAgentFileUploadToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'GET',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context12.abrupt("return", this.fetchJson({
                path: 'agents/v1/media/upload/credentials',
                options: options
              }));
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getAgentFileUploadToken(_x14) {
        return _getAgentFileUploadToken.apply(this, arguments);
      }
      return getAgentFileUploadToken;
    }()
  }, {
    key: "createAgent",
    value: function () {
      var _createAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context13.abrupt("return", this.fetchJson({
                path: '/agents/v1',
                options: options
              }));
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function createAgent(_x15, _x16) {
        return _createAgent.apply(this, arguments);
      }
      return createAgent;
    }()
  }, {
    key: "updateAgent",
    value: function () {
      var _updateAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(id, payload, controller) {
        var headers, options, response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              options = {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              _context14.next = 4;
              return this.fetchJson({
                path: "/agents/v1/".concat(id),
                options: options
              });
            case 4:
              response = _context14.sent;
              return _context14.abrupt("return", response);
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function updateAgent(_x17, _x18, _x19) {
        return _updateAgent.apply(this, arguments);
      }
      return updateAgent;
    }()
  }, {
    key: "deleteAgent",
    value: function () {
      var _deleteAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(id, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'DELETE',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              return _context15.abrupt("return", this.fetchJson({
                path: "/agents/v1/".concat(id),
                options: options
              }));
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function deleteAgent(_x20, _x21) {
        return _deleteAgent.apply(this, arguments);
      }
      return deleteAgent;
    }()
  }, {
    key: "favouriteAgent",
    value: function () {
      var _favouriteAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(id, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'POST',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              this.fetch({
                path: "/agents/v1/".concat(id, "/favourite"),
                options: options
              });
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function favouriteAgent(_x22, _x23) {
        return _favouriteAgent.apply(this, arguments);
      }
      return favouriteAgent;
    }()
  }, {
    key: "unfavouriteAgent",
    value: function () {
      var _unfavouriteAgent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(id, controller) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              headers = this.createHeaders();
              options = {
                method: 'DELETE',
                headers: headers,
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              this.fetch({
                path: "/agents/v1/".concat(id, "/favourite"),
                options: options
              });
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function unfavouriteAgent(_x24, _x25) {
        return _unfavouriteAgent.apply(this, arguments);
      }
      return unfavouriteAgent;
    }()
  }, {
    key: "createConversationChannel",
    value: function () {
      var _createConversationChannel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(options) {
        var _options$name, _options$dialogues;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", this.fetchJson({
                path: '/chat/v1/channel',
                options: {
                  method: 'POST',
                  headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                  }),
                  body: JSON.stringify({
                    name: (_options$name = options === null || options === void 0 ? void 0 : options.name) !== null && _options$name !== void 0 ? _options$name : generateConversationName(),
                    dialogues: (_options$dialogues = options === null || options === void 0 ? void 0 : options.dialogues) !== null && _options$dialogues !== void 0 ? _options$dialogues : undefined
                  })
                }
              }));
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function createConversationChannel(_x26) {
        return _createConversationChannel.apply(this, arguments);
      }
      return createConversationChannel;
    }()
  }, {
    key: "getConversationChannels",
    value: function () {
      var _getConversationChannels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", this.fetchJson({
                path: '/chat/v1/channels',
                options: {
                  method: 'GET',
                  headers: this.createHeaders()
                }
              }));
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getConversationChannels() {
        return _getConversationChannels.apply(this, arguments);
      }
      return getConversationChannels;
    }()
  }, {
    key: "updateConversationChannel",
    value: function updateConversationChannel(id, payload) {
      return this.fetchJson({
        path: "/chat/v1/channel/".concat(id),
        options: {
          method: 'PUT',
          headers: this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
          }),
          body: JSON.stringify(payload)
        }
      });
    }
  }, {
    key: "resolveConversationAction",
    value: function () {
      var _resolveConversationAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(id, payload) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", this.fetchJson({
                path: "/chat/v1/channel/".concat(id, "/action"),
                options: {
                  method: 'POST',
                  headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                  }),
                  body: JSON.stringify(_objectSpread(_objectSpread({}, payload), {}, {
                    context: _objectSpread(_objectSpread({}, payload.context), {}, {
                      browser_url: window.location.href
                    })
                  }))
                }
              }));
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function resolveConversationAction(_x27, _x28) {
        return _resolveConversationAction.apply(this, arguments);
      }
      return resolveConversationAction;
    }()
  }, {
    key: "speechToText",
    value: function () {
      var _speechToText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(blob) {
        var formData, response;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              formData = new FormData();
              formData.append('audio_recording', blob);
              _context21.next = 4;
              return this.fetchJson({
                path: '/speech/inference',
                options: {
                  method: 'POST',
                  headers: this.createHeaders(),
                  body: formData
                }
              });
            case 4:
              response = _context21.sent;
              return _context21.abrupt("return", response.transcription);
            case 6:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function speechToText(_x29) {
        return _speechToText.apply(this, arguments);
      }
      return speechToText;
    }()
  }, {
    key: "generateConversationStarters",
    value: function () {
      var _generateConversationStarters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(payload) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
              };
              return _context22.abrupt("return", this.fetchJson({
                path: '/agents/v1/suggest-conversation-starter',
                options: options
              }));
            case 3:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function generateConversationStarters(_x30) {
        return _generateConversationStarters.apply(this, arguments);
      }
      return generateConversationStarters;
    }()
  }, {
    key: "generateContextualConversationStarters",
    value: function () {
      var _generateContextualConversationStarters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(payload) {
        var headers, options;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
              };
              return _context23.abrupt("return", this.fetchStream({
                path: '/agents/v1/conversation-starter',
                options: options
              }));
            case 3:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function generateContextualConversationStarters(_x31) {
        return _generateContextualConversationStarters.apply(this, arguments);
      }
      return generateContextualConversationStarters;
    }()
  }, {
    key: "submitUserFeedback",
    value: function () {
      var _submitUserFeedback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(payload, controller) {
        var headers, conversation_channel_id, message_id, options;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
              });
              conversation_channel_id = payload.conversation_channel_id, message_id = payload.message_id;
              options = {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller === null || controller === void 0 ? void 0 : controller.signal
              };
              _context24.next = 5;
              return this.fetch({
                path: "/chat/v1/channel/".concat(conversation_channel_id, "/message/").concat(message_id, "/feedback"),
                options: options
              });
            case 5:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function submitUserFeedback(_x32, _x33) {
        return _submitUserFeedback.apply(this, arguments);
      }
      return submitUserFeedback;
    }()
  }]);
  return AssistanceServiceImpl;
}();
var AssistanceServiceContext = /*#__PURE__*/createContext(new AssistanceServiceImpl({
  baseUrl: '',
  product: '',
  experienceId: ''
}));
export var AssistanceServiceProvider = function AssistanceServiceProvider(_ref6) {
  var value = _ref6.value,
    children = _ref6.children;
  return /*#__PURE__*/React.createElement(AssistanceServiceContext.Provider, {
    value: value
  }, children);
};
/** If these props are provided and one of them are populated, they will take precedence over the `AssistanceServiceProvider` with the missing props filled in */
export var useAssistanceService = function useAssistanceService(props) {
  var _props$product, _props$product2, _props$experienceId;
  var service = useContext(AssistanceServiceContext);
  setRovoChatProduct((_props$product = props === null || props === void 0 ? void 0 : props.product) !== null && _props$product !== void 0 ? _props$product : service.getConfig().product);
  if (!props || !props.experienceId && !props.product) {
    return service;
  }
  var product = (_props$product2 = props.product) !== null && _props$product2 !== void 0 ? _props$product2 : service.getConfig().product;
  return new AssistanceServiceImpl(_objectSpread(_objectSpread({}, service.getConfig()), {}, {
    product: product,
    experienceId: (_props$experienceId = props.experienceId) !== null && _props$experienceId !== void 0 ? _props$experienceId : service.getConfig().experienceId
  }));
};